"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredFileTypes = exports.isFileTypeSupported = exports.getFileType = exports.invalidFileFormatError = exports.createNewBlockOrUseExistingOneError = exports.uploadOverTenFilesIsForbiddenError = exports.canOnlyReplaceOneFileError = exports.SUPPORTED_FILE_TYPES_BY_MIME_TYPE = exports.MAX_FILES_LENGTH_FOR_EXISTING_BLOCK = exports.MAX_FILES_LENGTH_FOR_NEW_BLOCK = exports.DEFAULT_OPTIONS = void 0;
var constants_1 = require("../../constants");
var toast_1 = require("../toast");
var localization_1 = require("../localization");
var fileName_1 = require("../../utils/fileName");
exports.DEFAULT_OPTIONS = {
    allowedContentType: 'all',
    createNewBlockOrUseExistingOneError: 'createNewBlockOrUseExistingOneToUploadFilesError'
};
exports.MAX_FILES_LENGTH_FOR_NEW_BLOCK = 10;
exports.MAX_FILES_LENGTH_FOR_EXISTING_BLOCK = 20;
exports.SUPPORTED_FILE_TYPES_BY_MIME_TYPE = {
    image: constants_1.SUPPORTED_IMAGE_EXTENSIONS,
    audio: constants_1.SUPPORTED_AUDIO_EXTENSIONS,
    video: constants_1.SUPPORTED_VIDEO_EXTENSIONS,
    application: constants_1.SUPPORTED_DOCUMENT_EXTENSIONS,
    all: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], constants_1.SUPPORTED_IMAGE_EXTENSIONS, true), constants_1.SUPPORTED_AUDIO_EXTENSIONS, true), constants_1.SUPPORTED_VIDEO_EXTENSIONS, true), constants_1.SUPPORTED_DOCUMENT_EXTENSIONS, true)
};
function canOnlyReplaceOneFileError() {
    toast_1.toast.error((0, localization_1.localize)('canOnlyReplaceOneFileError'));
}
exports.canOnlyReplaceOneFileError = canOnlyReplaceOneFileError;
function uploadOverTenFilesIsForbiddenError() {
    toast_1.toast.error((0, localization_1.localize)('uploadOverTenFilesIsForbiddenError'));
}
exports.uploadOverTenFilesIsForbiddenError = uploadOverTenFilesIsForbiddenError;
function createNewBlockOrUseExistingOneError(errorKey) {
    toast_1.toast.error((0, localization_1.localize)(errorKey));
}
exports.createNewBlockOrUseExistingOneError = createNewBlockOrUseExistingOneError;
function invalidFileFormatError(title) {
    toast_1.toast.error((0, localization_1.localize)('invalidFileFormatError', { fileTitle: (0, fileName_1.getShortFileName)(title) }));
}
exports.invalidFileFormatError = invalidFileFormatError;
function getFileType(file) {
    var name = file.name;
    var fileType = name.split('.').reverse()[0];
    return fileType.toLowerCase();
}
exports.getFileType = getFileType;
function isFileTypeSupported(file, allowedMIMEType) {
    var _a;
    return (_a = exports.SUPPORTED_FILE_TYPES_BY_MIME_TYPE[allowedMIMEType]) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item === ".".concat(getFileType(file)); });
}
exports.isFileTypeSupported = isFileTypeSupported;
function getFilteredFileTypes(files, allowedMIMEType) {
    return __spreadArray([], files, true).sort(function (firstFile, secondFile) { return firstFile.name > secondFile.name ? 1 : -1; })
        .reduce(function (_a, file) {
        var allowed = _a.allowed, forbidden = _a.forbidden;
        isFileTypeSupported(file, allowedMIMEType) ? allowed.push(file) : forbidden.push(file);
        return {
            allowed: allowed,
            forbidden: forbidden
        };
    }, { allowed: [], forbidden: [] });
}
exports.getFilteredFileTypes = getFilteredFileTypes;
